export const MAX_YEAR = 1;

export const DATE_PICKER_SEARCH_OPTIONS = [
    'Injection_Date_Time',
    'Study_Date_Time'
];

export const SPACE_SPLIT_COLUMN_OPTIONS = [  
    "Contrast_Use",
    "Contrast_waste",
    "Syringe_Change",
    "Aborted_Phase",
    "Patient_weight",
    "Repetitive_Injections",
    "Aborted_Injections_Reason",
    "CME_Concentration",
    "Protocol_Change"
]

export const DATETIME_COLUMN_OPTIONS = [
    'Injection_Date_Time',
    'Study_Date_Time'
];

export const COLUMN_NAME_WIDTH_80 = [
    "ML_KG",
    
];

